import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/site/Form";
import { Wordmark } from "@/components/site/SiteHeader";
import { useAuth } from "@/lib/auth";
import { errMsg } from "@/lib/api";

export const AuthShell = ({ title, children }) => (
  <div className="flex min-h-screen items-start justify-center px-4 py-12 sm:items-center">
    <div className="w-full max-w-sm">
      <Wordmark />
      <div className="panel mt-6 p-6">
        <h1 className="text-2xl font-extrabold text-slate-900">{title}</h1>
        {children}
      </div>
    </div>
  </div>
);

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/dealer" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login(email, password);
      nav(loc.state?.from || "/dealer", { replace: true });
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell title="Dealer sign in">
      <form onSubmit={submit} className="mt-5 space-y-4" data-testid="login-form">
        <Field label="Email" htmlFor="email"><input id="email" type="email" autoComplete="username" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" /></Field>
        <Field label="Password" htmlFor="password"><input id="password" type="password" autoComplete="current-password" className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" /></Field>
        {err && <p className="text-sm font-medium text-destructive" role="alert" data-testid="login-error">{err}</p>}
        <Button type="submit" className="h-11 w-full" disabled={busy} data-testid="login-submit-button">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}</Button>
        <Link to="/dealer/forgot-password" className="link block text-sm" data-testid="forgot-password-link">Forgotten your password?</Link>
      </form>
    </AuthShell>
  );
}
